import "../../App.css";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React from "react";
import Sidebar from "../Sidebar";
import UserTab from "../UserTab";

function Reporte(props) {
  const { history } = props;

  const goTo = (path) => history.push(path);

  return (
    <div className="App">
      <Sidebar tipo="3" />
      <br />
      <UserTab nombre={"Reportes"} />
      <div id="login">
        <div className="container">
          <div style={{ textAlign: "left", padding: "8px 16px 0" }}>
            <button
              type="button"
              onClick={() => goTo("/Separacion")}
              className="btn btn-link"
              style={{
                padding: 0,
                color: "#6B5B95",
                textDecoration: "none",
                fontSize: 13,
              }}
            >
              ← Volver al inicio
            </button>
          </div>
          <br />
          <br />
          <div className="row justify-content-center align-items-center">
            <div className="col-md-12">
              <div
                className="ajuste col-md-4"
                style={{ cursor: "pointer" }}
                onClick={() => goTo("/Reporte/Autofin")}
              >
                <div className="borderSeparacion">
                  <br />
                  <i className="glyphicon glyphicon-folder-open iconSeparacion">
                    <p className="letrasSeparacion">Autofin</p>
                  </i>
                </div>
              </div>

              <div
                className="ajuste col-md-4"
                style={{ cursor: "pointer" }}
                onClick={() => goTo("/Reporte/Global")}
              >
                <div className="borderSeparacion">
                  <br />
                  <i className="glyphicon glyphicon-folder-open iconSeparacion">
                    <p className="letrasSeparacion">Global</p>
                  </i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(Reporte);
